import React from "react";

const StatsSection = () => {
  // Theme variables
  const ACCENT_COLOR = "var(--color-accent)";
  const PRIMARY_TEXT = "var(--color-primary)";
  const CARD_BG = "rgba(11, 15, 13, 0.95)"; // semi-transparent dark

  const stats = [
    { label: "Total impressions", value: "5.9M", change: "+1.9%" },
    { label: "Avg. CTR", value: "4.5%", change: "+3.5%" },
    { label: "Profile visits", value: "39.2K", change: "+12%" },
    { label: "Avg. clicks", value: "2.9K", change: "+2%" },
    { label: "Replies", value: "6.2K", change: "+16%" },
    { label: "Avg. reach", value: "36.6K", change: "+8%" },
    { label: "Reposts", value: "39.8K", change: "+10%" },
    { label: "Avg. likes", value: "7.9K", change: "+6%" },
  ];

  const sectionStyle = {
    padding: "60px 20px",
    background: "transparent", // fully transparent
    color: PRIMARY_TEXT,
    textAlign: "center",
  };

  const titleStyle = {
    fontSize: "2.2rem",
    marginBottom: "40px",
    color: ACCENT_COLOR,
    fontWeight: "800",
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "20px",
    maxWidth: "1000px",
    margin: "0 auto",
  };

  const cardStyle = {
    background: CARD_BG,
    border: "1px solid rgba(52, 152, 219, 0.2)",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  };

  const valueStyle = {
    fontSize: "1.8rem",
    fontWeight: "bold",
    color: ACCENT_COLOR,
    marginBottom: "5px",
  };

  const labelStyle = {
    color: "var(--color-secondary)",
    fontSize: "1rem",
    marginBottom: "10px",
  };

  const changeStyle = {
    marginTop: "8px",
    fontSize: "0.9rem",
    color: "#4ade80",
    fontWeight: "600",
    display: "block",
  };

  return (
    <section style={sectionStyle}>
      <h2 style={titleStyle}>Our Impact</h2>
      <div style={gridStyle}>
        {stats.map((stat, index) => (
          <div
            key={index}
            style={cardStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.03)";
              e.currentTarget.style.boxShadow = `0 10px 30px ${ACCENT_COLOR}33`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.5)";
            }}
          >
            <h3 style={valueStyle}>{stat.value}</h3>
            <p style={labelStyle}>{stat.label}</p>
            <span style={changeStyle}>{stat.change}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
